import client from '../helpers/HttpClient';
import handleError from '../helpers/error';

class reportService {
  async fetchWorkJourney(params) {
    try {
      const result = await client.get('user/workjourney', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchActivityIntervals(params) {
    try {
      const result = await client.get('useractivityinterval/index', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchActivitySummary(params) {
    try {
      const result = await client.get('useractivityinterval/summary', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchActivityDashboard(params) {
    try {
      const result = await client.get('useractivityinterval/dashboard', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchAppActivitySummary(params) {
    try {
      const result = await client.get('userappactivity/summary', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchLastContact(params) {
    try {
      const result = await client.get('report/lastcontact', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async createNotification(obj) {
    try {
      const result = await client.post('notification/create', obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async migrateActivityIntervals() {
    try {
      const result = await client.post('useractivityinterval/migrate');
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async reprocessJourneyIntervals() {
    try {
      const result = await client.post('useractivityinterval/reprocessjourney');
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchAccess(params) {
    try {
      const result = await client.get('report/authlogreport', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchMailLog(params) {
    try {
      const result = await client.get('report/maillogreport', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchMailLogAttachment(id) {
    try {
      const result = await client.get(`report/maillogattachment/${id}`);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchIntegrationLog(params) {
    try {
      const result = await client.get('report/integrationlog', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchRequestsPerManager(params) {
    try {
      const result = await client.get('report/requestspermanager', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchNotifications(params) {
    try {
      const result = await client.get('notification/index', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchLicenseUsageCurrent() {
    try {
      const result = await client.get('licenseusagereport/current');
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchLicenseUsageHistory(params) {
    try {
      const result = await client.get('licenseusagereport/history', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchLicenseUsageFile(params) {
    try {
      const url = params.exportPdf ? 'licenseusagereport/pdf' : 'licenseusagereport/xlsx';
      const result = await client.get(url, { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchApprovedRequests(params) {
    try {
      const url = params.exportPdf ? 'approvedrequestsreport/pdf' : (params.export ? 'approvedrequestsreport/xlsx' : 'approvedrequestsreport/index');
      const result = await client.get(url, { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchSessionsReport(params) {
    try {
      const url = params.exportPdf ? 'sessionsreport/pdf' : (params.export ? 'sessionsreport/xlsx' : 'sessionsreport/index');
      const result = await client.get(url, { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchAccessOutsideJourney(params) {
    try {
      const url = params.exportPdf ? 'accessoutsidejourneyreport/pdf' : (params.export ? 'accessoutsidejourneyreport/xlsx' : 'accessoutsidejourneyreport/index');
      const result = await client.get(url, { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchUsersWithoutContactPdf(params) {
    try {
      const result = await client.get('userswithoutcontactreport/pdf', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }
}

export default new reportService();
